/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core'

export enum LoaderModes {
  PERSONAL_DATA = 'PERSONAL_DATA',
  ORDERS = 'ORDERS',
}

@Component({
  selector: 'pidx-skeleton-loader',
  templateUrl: './pidx-skeleton-loader.component.html',
  styleUrls: ['./pidx-skeleton-loader.component.scss'],
  standalone: false,
  // Angular 22 changed the implicit default to OnPush (see angular/angular#67687). This component was never migrated
  // to OnPush semantics, so Eager restores the pre-v22 behaviour it relies on.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PidxSkeletonLoaderComponent {
  LoaderModes = LoaderModes

  @Input() loaderMode: LoaderModes = LoaderModes.PERSONAL_DATA
  /**
   * Screen-reader-only label announced via the live region while the skeleton
   * is visible. Translated by the caller.
   */
  @Input() loadingLabel?: string

  @HostBinding('attr.role') role = 'status'
  @HostBinding('attr.aria-live') ariaLive = 'polite'
  @HostBinding('attr.aria-busy') ariaBusy = 'true'
}
